module.exports = __webpack_public_path__ + "media/icons/times-8365e70a.png";